"use client";

import { TitleH4 } from "@/components/shared/public";
import { BUSINESS_INFO } from "@/lib/business-info";
import { useTranslations } from "next-intl";
import Section from "../Section";

const addressVars = {
  legalName: BUSINESS_INFO.legalName,
  street: BUSINESS_INFO.street,
  postalCode: BUSINESS_INFO.postalCode,
  city: BUSINESS_INFO.city,
  ceo: BUSINESS_INFO.ceo,
  email: BUSINESS_INFO.email,
};

const DataPrivacy = () => {
  const t = useTranslations("privacyPolicy");

  return (
    <div className="gs--page-column flex flex-col gap-5 py-16">
      {/* Section 1 */}
      <Section
        title={t("section1.blocks.block1.title")}
        topic={t("section1.blocks.block1.topic")}
      >
        <p>{t("section1.blocks.block1.text1", addressVars)}</p>
        <p>{t("section1.blocks.block1.text2")}</p>
        <p>{t("section1.blocks.block1.text3")}</p>
      </Section>

      {/* Section 2 */}
      <Section title={t("section2.blocks.block1.title")}>
        <p>{t("section2.blocks.block1.text1")}</p>
        <p>{t("section2.blocks.block1.text2", addressVars)}</p>
        <p>{t("section2.blocks.block1.text3", addressVars)}</p>
      </Section>

      {/* Section 3 */}
      <Section
        title={t("section3.blocks.block1.title")}
        topic={t("section3.blocks.block1.topic")}
      >
        <p>{t("section3.blocks.block1.text1")}</p>
        <ul className="list-disc pl-10">
          <li>{t("section3.blocks.block1.li1")}</li>
          <li>{t("section3.blocks.block1.li2")}</li>
          <li>{t("section3.blocks.block1.li3")}</li>
          <li>{t("section3.blocks.block1.li4")}</li>
          <li>{t("section3.blocks.block1.li5")}</li>
          <li>{t("section3.blocks.block1.li6")}</li>
        </ul>
        <p>{t("section3.blocks.block1.text2")}</p>
        <p>{t("section3.blocks.block1.text3")}</p>
        <p>{t("section3.blocks.block1.text4")}</p>
      </Section>

      <Section topic={t("section3.blocks.block2.topic")}>
        <p>{t("section3.blocks.block2.text1")}</p>
        <p>{t("section3.blocks.block2.text2")}</p>
        <p>{t("section3.blocks.block2.text3")}</p>
        <p>{t("section3.blocks.block2.text4")}</p>
        <p>{t("section3.blocks.block2.text5")}</p>
      </Section>

      <Section topic={t("section3.blocks.block3.topic")}>
        <p>{t("section3.blocks.block3.text1")}</p>
        <p>{t("section3.blocks.block3.text2")}</p>
      </Section>

      <Section topic={t("section3.blocks.block4.topic")}>
        <p>{t("section3.blocks.block4.text1")}</p>
        <p>{t("section3.blocks.block4.text2")}</p>
      </Section>

      <Section topic={t("section3.blocks.block5.topic")}>
        <p>{t("section3.blocks.block5.text1")}</p>
        <p>{t("section3.blocks.block5.text2")}</p>
        <p>{t("section3.blocks.block5.text3")}</p>
      </Section>

      <Section topic={t("section3.blocks.block6.topic")}>
        <p>{t("section3.blocks.block6.text1")}</p>
      </Section>

      <Section topic={t("section3.blocks.block7.topic")}>
        <p>{t("section3.blocks.block7.text1")}</p>
        <p>{t("section3.blocks.block7.text2")}</p>
        <p>{t("section3.blocks.block7.text3")}</p>
        <p>{t("section3.blocks.block7.text4")}</p>
      </Section>

      <Section topic={t("section3.blocks.block8.topic")}>
        <p>{t("section3.blocks.block8.text1")}</p>
        <p>{t("section3.blocks.block8.text2")}</p>
        <p>{t("section3.blocks.block8.text3")}</p>
      </Section>

      <Section topic={t("section3.blocks.block9.topic")}>
        <p>{t("section3.blocks.block9.text1")}</p>
        <p>{t("section3.blocks.block9.text2")}</p>
        <p>{t("section3.blocks.block9.text3")}</p>
        <p>{t("section3.blocks.block9.text4")}</p>
        <p>{t("section3.blocks.block9.text5")}</p>
        <p>{t("section3.blocks.block9.text6")}</p>
      </Section>

      <Section topic={t("section3.blocks.block10.topic")}>
        <p>{t("section3.blocks.block10.text1")}</p>
        <ul className="list-disc pl-10">
          <li>{t("section3.blocks.block10.li1")}</li>
          <li>{t("section3.blocks.block10.li2")}</li>
          <li>{t("section3.blocks.block10.li3")}</li>
          <li>{t("section3.blocks.block10.li4")}</li>
          <li>{t("section3.blocks.block10.li5")}</li>
          <li>{t("section3.blocks.block10.li6")}</li>
          <li>{t("section3.blocks.block10.li7")}</li>
        </ul>
        <p>{t("section3.blocks.block10.text2")}</p>
        <p>{t("section3.blocks.block10.text3")}</p>
        <p>{t("section3.blocks.block10.text4")}</p>
        <p>{t("section3.blocks.block10.text5")}</p>
        <p>{t("section3.blocks.block10.text6")}</p>
      </Section>

      <Section topic={t("section3.blocks.block11.topic")}>
        <p>{t("section3.blocks.block11.text1")}</p>
        <p>{t("section3.blocks.block11.text2")}</p>
        <p>{t("section3.blocks.block11.text3")}</p>
        <ul className="list-disc pl-10">
          <li>{t("section3.blocks.block11.li1")}</li>
          <li>{t("section3.blocks.block11.li2")}</li>
          <li>{t("section3.blocks.block11.li3")}</li>
          <li>{t("section3.blocks.block11.li4")}</li>
        </ul>
      </Section>

      <Section topic={t("section3.blocks.block12.topic")}>
        <TitleH4 title={t("section3.blocks.block12.headline1")} />
        <p>{t("section3.blocks.block12.text1")}</p>
        <p>{t("section3.blocks.block12.text2")}</p>
        <p>{t("section3.blocks.block12.text3")}</p>
        <TitleH4 title={t("section3.blocks.block12.headline2")} />
        <p>{t("section3.blocks.block12.text4")}</p>
        <p>{t("section3.blocks.block12.text5")}</p>
        <p>{t("section3.blocks.block12.text6")}</p>
        <p>{t("section3.blocks.block12.text7")}</p>
        <TitleH4 title={t("section3.blocks.block12.headline3")} />
        <p>{t("section3.blocks.block12.text8")}</p>
        <p>{t("section3.blocks.block12.text9")}</p>
        <p>{t("section3.blocks.block12.text10")}</p>
      </Section>

      <Section topic={t("section3.blocks.block13.topic")}>
        <p>{t("section3.blocks.block13.text1")}</p>
        <p>{t("section3.blocks.block13.text2")}</p>
        <p>{t("section3.blocks.block13.text3")}</p>
      </Section>

      {/* Section 4 */}
      <Section title={t("section4.blocks.block1.title")}>
        <p>{t("section4.blocks.block1.text1")}</p>
        <p>{t("section4.blocks.block1.text2")}</p>
      </Section>

      {/* Section 5 */}
      <Section title={t("section5.blocks.block1.title")}>
        <p>{t("section5.blocks.block1.text1")}</p>
      </Section>

      {/* Section 6 */}
      <Section title={t("section6.blocks.block1.title")}>
        <p>{t("section6.blocks.block1.text1")}</p>
        <ul className="list-disc pl-10">
          <li>{t("section6.blocks.block1.li1")}</li>
          <li>{t("section6.blocks.block1.li2")}</li>
        </ul>
      </Section>

      {/* Section 7 */}
      <Section title={t("section7.blocks.block1.title")}>
        <p>{t("section7.blocks.block1.text1")}</p>
      </Section>

      {/* Section 8 */}
      <Section title={t("section8.blocks.block1.title")}>
        <p>{t("section8.blocks.block1.text1")}</p>
        <p>{t("section8.blocks.block1.text2")}</p>
        <p>{t("section8.blocks.block1.text3")}</p>
        <p>{t("section8.blocks.block1.text4")}</p>
        <p>{t("section8.blocks.block1.text5")}</p>
        <p>{t("section8.blocks.block1.text6")}</p>
        <p>{t("section8.blocks.block1.text7")}</p>
        <p>{t("section8.blocks.block1.text8")}</p>
        <p>{t("section8.blocks.block1.text9")}</p>
        <p>{t("section8.blocks.block1.text10")}</p>
        <p>{t("section8.blocks.block1.text11")}</p>
        <p>{t("section8.blocks.block1.text12")}</p>
        <p>{t("section8.blocks.block1.text13", addressVars)}</p>
        <p>{t("section8.blocks.block1.text14", addressVars)}</p>
        <p>{t("section8.blocks.block1.text15")}</p>
        <p>{t("section8.blocks.block1.text16")}</p>
        <p>{t("section8.blocks.block1.text17", addressVars)}</p>
      </Section>

      {/* Section 9 */}
      <Section title={t("section9.blocks.block1.title")}>
        <p>{t("section9.blocks.block1.text1")}</p>
      </Section>

      {/* Section 10 */}
      <Section title={t("section10.blocks.block1.title")}>
        <p>{t("section10.blocks.block1.text1")}</p>
      </Section>

      {/* Section 11 */}
      <Section title={t("section11.blocks.block1.title")}>
        <ul className="list-disc pl-10">
          <li>{t("section11.blocks.block1.li1")}</li>
          <li>{t("section11.blocks.block1.li2")}</li>
        </ul>
      </Section>
    </div>
  );
};

export default DataPrivacy;
